import React, { useEffect, useRef, useState } from "react";
import FireOnMenu from "./FireOnMenu";
import DashboardMenu from "./DashboardMenu";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { getDateTime } from "../../utils/date";
import { getFireAlarmHistoryResultName } from "../../utils/common";
import PageHeader from "../PageHeader";

export default function FireAlarmLogComponent() {
    const itemsPerPage = 100;
    const { id } = useParams();
    const location = useLocation();
    const { buildingName } = location.state;
    const [dataSource, setDataSource] = useState([]);
    const [page, setPage] = useState(1);
    const [next, setNext] = useState(null);
    const scrollRef = useRef();
    const pageRef = useRef(page);
    const nextRef = useRef(next);

    useEffect(() => {
        const scrollWrap = scrollRef.current;

        const handleScroll = () => {
            if (scrollWrap.scrollTop + scrollWrap.clientHeight >= scrollWrap.scrollHeight - 5) {
                if (nextRef.current) {
                    getData(pageRef.current + 1);
                }
            }
        }

        scrollWrap.addEventListener('scroll', handleScroll);

        getData(page);

        return () => {
            scrollWrap.removeEventListener('scroll', handleScroll);
        }
    }, []);

    useEffect(() => {
        pageRef.current = page;
    }, [page]);

    useEffect(() => {
        nextRef.current = next;
    }, [next]);

    const getData = (page) => {
        apiWrapper(async () => {
            const result = await fireonApi.getFireAlarmHistoryList(id, '', '', page, itemsPerPage);

            const { status, data } = result;
            if (status === true) {
                setDataSource((prevDataSource) => {
                    if (prevDataSource.some(item => item.page === page)) {
                        return prevDataSource;
                    }

                    return [
                        ...prevDataSource,
                        {
                            page: page,
                            results: data.results,
                        }
                    ]
                });

                setNext(data.next);
                setPage(page);
            } else {
                alert(`${data}`);
            }
        });
    }

    return (
        <section id="darkMode" class="mbSection darkMode">
            <PageHeader isBlack={true} title={buildingName} isUseMenu={true} />
            <div class="container">
                <p class="tableTitle mt-24 mb-20 pb-10 bb-w">화재경보 발생이력</p>
                <div class="tableList FAHlist">
                    <div ref={scrollRef} class="config-row-wrap scroll-wrap type-273">
                        {dataSource &&
                            dataSource.length > 0 &&
                            dataSource.map((pageItem) => {
                                if (pageItem.results.length > 0) {
                                    return pageItem.results.map((item, index) => (
                                        <Link class="config-row" to={`/fire-on/fire-alarm-log/${id}/report/${item.id}/`} state={location.state} >
                                            <div class="top-wrap">
                                                <div class="config-number">
                                                    <p class="row-num">{item.id}</p>
                                                </div>
                                                <div class="alarm-info">
                                                    <p class="info-id">{item.description}</p>
                                                    <div class="info-datetime">
                                                        <div class="datetime-wrap">
                                                            <p class="datetime-title">발생일시&nbsp;:&nbsp;</p>
                                                            <p class="datetime-txt">{getDateTime(new Date(item.eventTime))}</p>
                                                        </div>
                                                        <span class="divi"></span>
                                                        <div class="datetime-wrap">
                                                            <p class="datetime-title">확인일시&nbsp;:&nbsp;</p>
                                                            <p class="datetime-txt">{item.confirmedAt ? getDateTime(new Date(item.confirmedAt)) : null}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="action-box">
                                                <div class="action-item-wrap">
                                                    <p class="item-title">확인 조치사항</p>
                                                    <p class="item-txt">{item.action}</p>
                                                </div>
                                                <div class="action-item-wrap">
                                                    <p class="item-title">결과</p>
                                                    <p class="item-txt">{getFireAlarmHistoryResultName(item.resultType)}</p>
                                                </div>
                                            </div>
                                        </Link>
                                    ))
                                }
                            })}
                    </div>
                </div>
            </div>
            <div id="dashboardMenu" class="">
                <DashboardMenu buildingName={buildingName} />
            </div>
            <FireOnMenu />
        </section>
    );
}
